/**
 * Formats Polygon2D properties: the fill colour, vertex count, offset and
 * texture reference, then the shared Node2D sections.
 */
import { formatNode2DProperties } from '../../base/node2d/propertyFormatter';
export function formatPolygon2DProperties(properties) {
    const sections = [];
    const { color, offset } = properties;
    const vertexCount = Math.floor(properties.polygon.length / 2);
    sections.push({
        title: 'Polygon',
        items: [
            { label: 'Vertices', value: vertexCount.toString() },
            {
                label: 'Color',
                value: `(${color.r}, ${color.g}, ${color.b}, ${color.a})`,
            },
            { label: 'Offset', value: `(${offset.x}, ${offset.y})` },
            { label: 'Texture', value: properties.texture ?? '(none)' },
        ],
    });
    sections.push(...formatNode2DProperties(properties));
    return sections;
}
//# sourceMappingURL=propertyFormatter.js.map